/*eslint-disable max-len*/
import React, { Component } from 'react';
import * as MaterialUI from '@material-ui/core';

const { SvgIcon } = MaterialUI;

class PencilIcon extends Component {
	constructor(props) {
		super(props);
		this.props = props;
	}

	render() {
		return (
			<SvgIcon width="24" height="24" viewBox="0 0 24 24" {...(this.props)}>
				<path d="M16.6168 3.75204C16.8552 3.51361 17.1383 3.32448 17.4498 3.19545C17.7613 3.06641 18.0952 3 18.4324 3C18.7696 3 19.1035 3.06641 19.415 3.19545C19.7265 3.32448 20.0095 3.51361 20.248 3.75204C20.4864 3.99046 20.6755 4.27351 20.8046 4.58503C20.9336 4.89655 21 5.23043 21 5.56761C21 5.90479 20.9336 6.23868 20.8046 6.55019C20.6755 6.86171 20.4864 7.14476 20.248 7.38319L7.99283 19.6383L3 21L4.36168 16.0072L16.6168 3.75204Z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			</SvgIcon>
		);
	}
}

export default PencilIcon;


// WEBPACK FOOTER //
// ./src/components/icons/pencil.js